module.exports = __webpack_public_path__ + "img/enigma-3.4f6d02ba.png";